import { render, staticRenderFns } from "./DialogTabBar.vue?vue&type=template&id=3710a151&scoped=true"
import script from "./DialogTabBar.vue?vue&type=script&lang=js"
export * from "./DialogTabBar.vue?vue&type=script&lang=js"
import style0 from "./DialogTabBar.vue?vue&type=style&index=0&id=3710a151&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3710a151",
  null
  
)

export default component.exports